import { NextPage, GetStaticProps, GetServerSideProps } from 'next';
import * as React from "react";
import { Page, Card, AllPages } from "../src/types";

import {
  fetchContentfulEntry,
  fetchContentfulPosts,
  fetchContentfulGlobals,
} from "../src/lib/utils";

import Layout from "../src/components/Layout";
import PageContainer from "../src/containers/PageContainerSections";

interface Props {
  page: Page;
  posts: Card[];
  global: AllPages;
}
export const IndexPage: NextPage<Props> = ({ page, posts, global }) => {
  return (
    <Layout title={page.navigationTitle} allPages={global}>
      <PageContainer page={page} posts={posts} allPages={global} />
    </Layout>
  );
};
export const getStaticProps: GetStaticProps = async (context) => {
  const page = await fetchContentfulEntry(`/`, context.preview);
  const posts = await fetchContentfulPosts(context.preview, { length: 3 });
  const global = await fetchContentfulGlobals(context.preview);

  return {
    props: {
      page,
      posts,
      global,
    },
  };
};
export default IndexPage;
